import React from "react";
import PropTypes from "prop-types";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import swal from "sweetalert2";
import DatePicker from "react-datepicker";
import shortid from "shortid";
import moment from "moment";
import "react-datepicker/dist/react-datepicker.css";
import BeneReceiptList from "./BeneReceiptList";
import { isEmpty, isIn, isEmail } from "validator";
import {
  getBeneficiaryDetail,
  getContactDetail,
  getPicklist,
  save,
  getApplicationDetail,
  getBeneAttachment,
  setApprover,
  sendNotifApprover,
} from "./actions";
import {
  BeneficiaryForOfficialUse,
  BeneficiaryContactDetail,
  BeneficiaryInformation,
  BeneficiaryAppInformation,
} from "./components";
import {
  describeAllObject,
  getAllSchool,
  getPicklist as getPicklistPerson,
  validateInput,
} from "../Registration/actions";
import { getBase64 } from "../../../utils/common";
import { createTermination } from "../Termination/actions";
import { saveAttachment } from "../Application/actions";
import BeneficiaryAttachment from "./BeneficiaryAttachment";
import TrackedField from "../common/TrackedField";
import { spmfcloudFunctionUrl } from "../../../actions/salesforces";
import { validateNRIC } from "../../../utils/common";

class BeneficiaryDetail extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      form: {},
      beneDetail: null,
      applicationDetail: null,
      attachmentList: [],
      newAttachments: [],
      loading: false,
      editMode: false,
      showModal: false,
      isActive: null,
      approver: [],
      approverModalVisible: false,
      errorMessage: {},
    };
    this.createTermination = createTermination.bind(this);
    this.onUpload = this.onUpload.bind(this);
    this.onSaveUpload = this.onSaveUpload.bind(this);
    this.onRemove = this.onRemove.bind(this);
    this.changeStatus = this.changeStatus.bind(this);
    this.onChange = this.onChange.bind(this);
    this.validateInputBene = this.validateInputBene.bind(this);
    this.getPicklist = getPicklist.bind(this);
    this.save = save.bind(this);
    this.getApprover = this.getApprover.bind(this);
    this.changeFormValue = this.changeFormValue.bind(this);
    this.submitApprover = this.submitApprover.bind(this);
    this.firstFetch = this.firstFetch.bind(this);
    this.validationList = this.validationList.bind(this);
    this.sendNotification = this.sendNotification.bind(this);
  }

  async firstFetch() {
    this.setState({ loading: true });
    try {
      ``;
      const { user } = this.props;
      this.props.describeAllObject(); //get picklist value from salesforce
      this.props.getAllSchool(); //get list of school from sf object
      const detail = await getBeneficiaryDetail(
        this.props.match.params.id,
        user.siteToken.hash,
        user.key
      );
      const contactDetail = await getContactDetail(
        this.props.match.params.id,
        user.siteToken.hash,
        user.key
      );
      let attachmentList = { records: [] };
      let applicationDetail = { records: [] };
      if (detail.records[0]) {
        //page can show data of beneficiary / household member
        if (detail.records[0].RecordType.Name === "Household Member") {
          applicationDetail = await getApplicationDetail(
            detail.records[0].Application__c,
            user.siteToken.hash,
            user.key
          );
        }
        if (detail.records[0].RecordType.Name === "Beneficiary") {
          attachmentList = await getBeneAttachment(
            this.props.match.params.id,
            user.siteToken.hash,
            user.key
          );
        }
      }

      const beneDetail = detail.records[0] || {};
      this.setState({
        beneDetail: beneDetail,
        contactDetail: contactDetail.records[0] || {},
        applicationDetail: applicationDetail.records[0] || {},
        attachmentList: attachmentList || {},
        isActive: contactDetail.records[0]
          ? contactDetail.records[0].Active__c
          : false,
        form: {
          Terminating_Beneficary__c: contactDetail.records[0]
            ? contactDetail.records[0].Id
            : null,
        },
        loading: false,
      });
      this.validationList(beneDetail); //trigger validation indicator on first render
    } catch (error) {
      swal({
        text: error.toString(),
        title: "Error when retriving beneficiary",
        type: "error",
      });
    }
  }

  validationList(beneDetail) {
    //validation define from spmf request. this trigger on first fetch and onchange field
    this.validateInputBene(
      {
        Full_Name__c: {
          message: "Full name is required",
          validate: (val) => !isEmpty(val || ""),
        },
        ID_Number__c: {
          message: "Invalid FIN or NRIC",
          validate: (val) =>
            beneDetail.ID_Type__c !== "Others"
              ? validateNRIC(val || "")
              : !isEmpty(val || ""),
        },
        Date_of_Birth__c: {
          validate: (val) => {
            const yearDiff = moment().diff(val, "years");
            return beneDetail.RecordType.Name === "Household Member"
              ? beneDetail.Main_Applicant__c
                ? yearDiff >= 18
                : true
              : yearDiff >= 6 && yearDiff <= 21;
          },
          message:
            beneDetail.RecordType.Name === "Household Member"
              ? "minimum age should be 18 years old"
              : "Beneficiary’s age must be 6-21 years old",
        },
        Contact_Number__c: {
          validate: (val) =>
            /^[0-9]{8,8}$/g.test(val ? val.toString() : "") ||
            isEmpty(val || ""),
          message: "Invalid mobile phone number",
        },
        Mobile_Phone__c: {
          validate: (val) =>
            /^[0-9]{8,8}$/g.test(val ? val.toString() : "") ||
            isEmpty(val || ""),
          message: "Invalid mobile phone number",
        },
        Office_Phone__c: {
          validate: (val) =>
            /^[0-9]{8,8}$/g.test(val ? val.toString() : "") ||
            isEmpty(val || ""),
          message: "Invalid office number",
        },
        Home_Phone__c: {
          validate: (val) =>
            /^[0-9]{8,8}$/g.test(val ? val.toString() : "") ||
            isEmpty(val || ""),
          message: "Invalid homephone number",
        },
        Email_Address__c: {
          validate: (val) => isEmpty(val || "") || isEmail(val || ""),
          message: "Invalid email address",
        },
      },
      false,
      beneDetail
    );
  }

  async componentWillMount() {
    await this.firstFetch();
  }

  onChange(attributeName, value) {
    const { applicationDetail, beneDetail } = this.state;
    if (attributeName === "multiStateChangeBene" && typeof value === "object") {
      this.setState({
        beneDetail: {
          ...beneDetail,
          ...value,
        },
      });
    } else if (attributeName === "Other_Source_of_Income_Amount__c") {
      this.setState({
        applicationDetail: {
          ...applicationDetail,
          [attributeName]: value,
        },
      });
    } else if (attributeName === "Payout_Start__c") {
      this.setState({
        beneDetail: {
          ...beneDetail,
          [attributeName]: value.format("YYYY-MM-DD"),
        },
      });
    } else if (attributeName === "Incomplete_Document__c") {
      this.setState({
        beneDetail: {
          ...beneDetail,
          [attributeName]: value,
        },
      });
    } else if (attributeName === "No_of_Receipts_Approved__c") {
      // No negative sign
      this.setState({
        beneDetail: {
          ...beneDetail,
          [attributeName]: value.replace(/-/g, ""),
        },
      });
    } else if (attributeName === "Relationship_to_Applicant__c") {
      this.setState({
        beneDetail: {
          ...beneDetail,
          [attributeName]: value,
          Relationship_to_Applicant_Other__c:
            value === "Others"
              ? beneDetail.Relationship_to_Applicant_Other__c
              : "",
        },
      });
    } else if (attributeName === "Relationship_to_Beneficiary__c") {
      this.setState({
        beneDetail: {
          ...beneDetail,
          [attributeName]: value,
          Relationship_to_Beneficiary_Other__c:
            value === "Others"
              ? beneDetail.Relationship_to_Beneficiary_Other__c
              : "",
        },
      });
    } else if (attributeName === "Nationality__c") {
      this.setState({
        beneDetail: {
          ...beneDetail,
          [attributeName]: value,
          Other_Nationality__c:
            value === "Others" ? beneDetail.Other_Nationality__c : "",
        },
      });
    } else if (attributeName === "Race__c") {
      this.setState({
        beneDetail: {
          ...beneDetail,
          [attributeName]: value,
          Other_Race__c: value === "Others" ? beneDetail.Other_Race__c : "",
        },
      });
    } else if (attributeName === "Marital_Status__c") {
      this.setState({
        beneDetail: {
          ...beneDetail,
          [attributeName]: value,
          Other_Marital_Status__c:
            value === "Others" ? beneDetail.Other_Marital_Status__c : "",
        },
      });
    } else if (attributeName === "Employment_Status__c") {
      this.setState({
        beneDetail: {
          ...beneDetail,
          [attributeName]: value,
          Occupation__c: value === "Unemployed" ? "" : beneDetail.Occupation__c,
          Monthly_Gross_Income__c:
            value === "Unemployed" ? "" : beneDetail.Monthly_Gross_Income__c,
          Company__c: value === "Unemployed" ? "" : beneDetail.Company__c,
        },
      });
    } else if (attributeName === "Other_Source_of_Income__c") {
      this.setState({
        applicationDetail: {
          ...applicationDetail,
          [attributeName]: value,
          Other_Source_of_Income_Amount__c:
            value === "None"
              ? ""
              : applicationDetail.Other_Source_of_Income_Amount__c,
        },
      });
    } else {
      const newBene = {
        ...beneDetail,
        [attributeName]: value,
      };
      this.setState({
        beneDetail: newBene,
      });
      this.validationList(newBene);
    }
  }

  validateInputBene(validationList = [], buttonValidation = false, beneDetail) {
    //this is to show indicator/error message when fulfill validation rules
    const { errorMessage } = this.state;
    Object.keys(buttonValidation ? validationList : beneDetail).forEach(
      (key) => {
        if (validationList[key] === undefined) return;
        if (typeof validationList[key].validate === "function") {
          if (validationList[key].validate(beneDetail[key]) === false) {
            errorMessage[key] =
              validationList[key].message ||
              `${key.replace(/__c|_/g, " ")} required`;
          } else {
            delete errorMessage[key];
          }
        }
      }
    );
    this.setState({ errorMessage });
    return Object.keys(errorMessage).length === 0;
  }

  //used to notify selected approver. on portal side its only updating single field and the rest is handled on salesforce
  async sendNotification() {
    if (!this.state.beneDetail.Approver_Name__r) {
      swal({
        text: "You Need to select Approver first!",
        title: "Error!",
        type: "error",
      });
      return;
    }

    let schedule = JSON.parse(localStorage.getItem("beneNotifSchedule")) || {};
    let thisSchedule = schedule[this.props.match.params.id] || [];
    const currentDate = new Date();
    if (thisSchedule.length > 0) {
      const compareCurrent = new Date();
      compareCurrent.setHours(0, 0, 0, 0);

      const thisDay = thisSchedule.filter((x) => {
        const compareDataDate = new Date(x.time);
        compareDataDate.setHours(0, 0, 0, 0);
        if (compareCurrent <= compareDataDate) {
          return true;
        } else {
          return false;
        }
      });

      if (thisDay.length < 2) {
        //have limitation how many times it send / day
        thisDay.push({ time: currentDate.toISOString() });
      } else {
        swal({
          text: "Unable to send Notification more than 2 times a day",
          title: "Error!",
          type: "error",
        });
        return;
      }

      schedule[this.props.match.params.id] = thisDay;
      localStorage.setItem("beneNotifSchedule", JSON.stringify(schedule));
    } else {
      const newSchedule = [{ time: currentDate.toISOString() }];
      schedule[this.props.match.params.id] = newSchedule;
      localStorage.setItem("beneNotifSchedule", JSON.stringify(schedule));
    }
    try {
      const data = {
        Id: this.props.match.params.id,
        Send_Approve_Request__c: true,
      };
      const response = await sendNotifApprover(
        data,
        this.props.user.siteToken.hash
      );
      const json = await response.json();
      if (!response.ok) {
        throw new Error(json.message);
      }
    } catch (error) {
      swal({
        text: error.toString(),
        title: "Error when retriving beneficiary",
        type: "error",
      });
    }
    swal({
      text: "Notification Sent!",
      title: "Success!",
      type: "success",
    });
  }

  //fetch list of available approver to select and send notification
  async getApprover() {
    try {
      const response = await fetch(
        `${spmfcloudFunctionUrl}/users/approver-partner`,
        {
          mode: "cors",
          cache: "no-cache",
          method: "GET",
          headers: {
            "hash-token": this.props.user.siteToken.hash,
            "Content-Type": "application/json",
          },
        }
      );

      const json = await response.json();
      if (!response.ok) {
        throw new Error(json.message);
      }

      const cloneJson = Object.assign({}, json);
      cloneJson.records = json.records.map((rec) => {
        const clone = Object.assign({}, rec);
        clone.Active__c = `${clone.Active__c}`;
        return clone;
      });
      this.setState({ approver: cloneJson.records });
      this.firstFetch();
    } catch (error) {
      swal({
        text: error.toString(),
        title: "Error when retriving beneficiary",
        type: "error",
      });
    }
  }

  //save the selected approver for beneficiary
  async submitApprover(approver) {
    try {
      const data = {
        Id: this.props.match.params.id,
        Approver_Name__c: approver.Id,
      };
      await setApprover(data, this.props.user.siteToken.hash);
    } catch (error) {
      swal({
        text: error.toString(),
        title: "Error when retriving beneficiary",
        type: "error",
      });
    }
  }

  //this 3 function under here is for attachment upload save and remove
  onUpload(event) {
    const { newAttachments } = this.state;
    const file = event.target.files[0];
    const fileName = file.name.replace(/ |-/g, "_");
    const attachment = {
      Name: fileName,
      Body: "",
      parentId: this.props.match.params.id,
      ContentType: file.type,
    };
    getBase64(file).then((encodedFile) => {
      attachment.Body = encodedFile.split(",")[1];
      newAttachments.push(attachment);
      this.setState({ newAttachments });
    });
  }

  onSaveUpload() {
    const siteToken = this.props.user.siteToken.hash;
    const { key: publicKey } = this.props.user;
    const attachedList = [];
    const beneId = this.props.match.params.id;
    this.state.newAttachments.map((attachment) => {
      attachedList.push(saveAttachment(attachment, siteToken));
    });
    Promise.all(attachedList)
      .then(() => {
        getBeneAttachment(beneId, siteToken, publicKey).then((res) => {
          this.setState({
            attachmentList: res,
            newAttachments: [],
          });
        });
      })
      .catch((err) => {
        swal({
          type: "error",
          text: err,
        });
      });
  }

  onRemove(event) {
    const attcIdx = Number(event.target.id.match(/\d+/)[0]);
    const { newAttachments } = this.state;
    newAttachments.splice(attcIdx, 1);
    this.setState({ newAttachments });
  }

  async changeStatus(status) {
    //reusable function for change status application of beneficiary
    try {
      if (this.state.loading) return;

      let dataToUpdate = {
        Id: this.state.beneDetail.Id,
        Application_Status__c: status,
      };

      const { beneDetail } = this.state;
      let newState = {};

      if (status === "Received") {
        const overwritingState = {
          // No_of_Receipt__c: 0,
          No_of_Receipts_Approved__c: 0,
          Approve_Exception__c: false,
          Payout_Start__c: "",
          Payout_End__c: "",
          Application_Status__c: status,
        };
        newState = Object.assign({}, beneDetail, overwritingState);

        // Change to null to accomodate Salesforce's REST API
        overwritingState.Payout_Start__c = null;
        overwritingState.Payout_End__c = null;
        // overwritingState.No_of_Receipt__c = null;
        overwritingState.No_of_Receipts_Approved__c = null;
        overwritingState.Extension_In_no_of_months__c = null;
        dataToUpdate = Object.assign({}, dataToUpdate, overwritingState);

        this.setState({ beneDetail: newState });
      } else if (status === "Verified by Partner") {
        if (beneDetail.Payout_Start__c === "") {
          throw new Error("Payout Start Month must not be empty");
        }

        // This doesn't apply to school partners
        if (
          beneDetail.No_of_Receipts_Approved__c < 1 &&
          this.props.user.loggedInUser.Account.Partner_Type__c !== "School"
        ) {
          throw new Error("No. of receipts approved must be more than 0");
        }

        dataToUpdate = Object.assign({}, dataToUpdate, {
          Payout_Start__c: beneDetail.Payout_Start__c,
          Payout_End__c: beneDetail.Payout_End__c,
          Approve_Exception__c: beneDetail.Approve_Exception__c,
          No_of_Receipts_Approved__c: beneDetail.No_of_Receipts_Approved__c,
          Extension_In_no_of_months__c: beneDetail.Extension_In_no_of_months__c
            ? beneDetail.Extension_In_no_of_months__c
            : "",
        });
      }

      this.setState({ loading: true });
      const response = await fetch(
        `${spmfcloudFunctionUrl}/update-bene-status`,
        {
          mode: "cors",
          body: JSON.stringify({
            data: dataToUpdate,
            applicationId: this.state.beneDetail.Application__c,
          }),
          cache: "no-cache",
          method: "POST",
          headers: {
            "hash-token": this.props.user.siteToken.hash,
            "Content-Type": "application/json",
          },
        }
      );

      const json = await response.json();
      if (!response.ok) {
        throw new Error(json.message);
      }

      swal({
        title: "Successfully update beneficiary status",
        text: `This beneficiary status has been updated to "${status}"`,
        type: "success",
      });

      this.setState({ loading: false });
      setTimeout(() => this.componentWillMount(), 1000);
    } catch (error) {
      // Reset Extension_In_no_of_months__c if there is any error when updating it
      // with status "Verified by Partner"
      const { beneDetail } = this.state;
      if (status === "Verified by Partner") {
        beneDetail.Extension_In_no_of_months__c = "";
      }

      swal({
        html: error.toString(),
        title: "An error occured when updating status",
        type: "error",
      });
      this.setState({ loading: false, beneDetail });
    }
  }

  changeFormValue(attribute, value) {
    this.setState({
      form: {
        ...this.state.form,
        [attribute]: value,
      },
    });
  }

  render() {
    const approver = this.props.user.loggedInUser.Partner_Authority__c
      ? this.props.user.loggedInUser.Partner_Authority__c.toLowerCase() ===
        "approver"
      : false;
    const partnerType = this.props.user.loggedInUser.Account.Partner_Type__c;
    let buttons = [];
    const { beneDetail, contactDetail, applicationDetail, editMode } =
      this.state;
    if (beneDetail === null) {
      return (
        <p style={{ textAlign: "center" }}>
          {this.state.loading ? (
            <i className="fa fa-3x fa-spinner fa-spin" />
          ) : null}
        </p>
      );
    }
    buttons = [
      //conditional render for button from each app status and record type. verifier and approver role on user also affect
      <button
        className="btn btn-info btn-fill"
        key={shortid.generate()}
        onClick={this.sendNotification}
      >
        Send Notification
      </button>,
      beneDetail.Application_Status__c === "Rejected by Verifier" ||
      beneDetail.Application_Status__c === "Verified by Partner" ? (
        <button
          type="button"
          className="btn btn-info"
          key={shortid.generate()}
          onClick={() => this.changeStatus("Received")}
        >
          <i className="fa fa-refresh" />
          &nbsp;Revert
        </button>
      ) : (
        ""
      ),
    ];
    if (approver) {
      if (beneDetail.RecordType.Name === "Beneficiary") {
        if (beneDetail.Application_Status__c === "Verified by Partner") {
          buttons.push(
            <button
              className="btn btn-success btn-fill"
              key={shortid.generate()}
              onClick={() => {
                if (
                  this.props.user.loggedInUser.Account.Partner_Type__c ===
                  "School"
                )
                  this.changeStatus("Submitted to SPMF");
                else {
                  this.changeStatus("Approved by Partner");
                }
              }}
            >
              <i className="fa fa-thumbs-up" /> Approve
            </button>,
            <button
              key={shortid.generate()}
              className="btn btn-danger btn-fill"
              onClick={() => this.changeStatus("Rejected By Partner")}
            >
              Reject
            </button>
          );
        } else if (beneDetail.Application_Status__c === "Received") {
          buttons.push(
            <button
              key={shortid.generate()}
              className="btn btn-danger btn-fill"
              onClick={() => this.changeStatus("Rejected By Partner")}
            >
              Reject
            </button>
          );
        }
      }
    } else if (
      beneDetail.Application_Status__c === "Received" &&
      beneDetail.RecordType.Name === "Beneficiary"
    ) {
      buttons.push(
        <button
          className="btn btn-success btn-fill"
          key={shortid.generate()}
          onClick={() => this.changeStatus("Verified by Partner")}
        >
          <i className="fa fa-check" /> Verify
        </button>
      );
      buttons.push(
        <button
          className="btn btn-danger btn-fill"
          key={shortid.generate()}
          onClick={async () => {
            await this.changeStatus("Rejected By Partner");
          }}
        >
          <i className="fa fa-thumbs-down" /> Reject
        </button>
      );
    }

    let applicationStatus = "";
    if (beneDetail.RecordType.Name === "Beneficiary") {
      applicationStatus = beneDetail.Application_Status__c;
    } else {
      applicationStatus = applicationDetail.Application_Status__c;
    }
    if (applicationStatus === "Received") {
      if (!editMode) {
        buttons.push(
          <button
            className="btn btn-default"
            onClick={() => this.setState({ editMode: true })}
            key="edit"
          >
            <i className="fa fa-pencil" /> Edit
          </button>
        );
      } else {
        buttons.push(
          <button
            className="btn btn-warning"
            onClick={() => this.setState({ editMode: false })}
            key="cancel"
          >
            Cancel
          </button>,
          <button
            className="btn btn-warning"
            onClick={this.save}
            key="Save"
            disabled={this.state.errorMessage.ID_Number__c}
          >
            <i className="fa fa-save" /> Save
          </button>
        );
      }
    } else if (/rejected by partner/gi.test(applicationStatus)) {
      buttons.push(
        <button
          className="btn btn-info btn-fill"
          key={shortid.generate()}
          onClick={() => this.changeStatus("Received")}
        >
          <i className="fa fa-refresh" /> Revert
        </button>
      );
    }

    //conditional values of level school for each school type define on subType
    const schoolList = Array.isArray(this.props.schoolList)
      ? this.props.schoolList.map((school) => ({
          value: school,
          label: school.Name,
          subType: school.Partner_SubType__c,
        }))
      : [];
    const subTypeMap = {
      "Primary School": "Primary",
      "Secondary School": "Secondary",
      SPED: "SPED",
      ITE: "NITEC",
      Polytechnic: "Polytechnic",
      "Junior College": "JC",
      "Pri/Sec School": ["Primary", "Secondary"],
      "Sec/JC School": ["Secondary", "JC"],
    };
    let allCurrentLevel = [];
    if (beneDetail.Current_School__r) {
      allCurrentLevel = getPicklistPerson(
        "Current_Level__c",
        this.props.objectInfo.Person__c,
        "object"
      );
      allCurrentLevel = allCurrentLevel.filter((obj) => {
        const typeCheck =
          subTypeMap[beneDetail.Current_School__r.Partner_SubType__c];
        if (typeof typeCheck === "string") {
          return obj.value.includes(typeCheck);
        }
        if (typeof typeCheck === "object") {
          const result = typeCheck.map((eachType) =>
            obj.value.includes(eachType)
          );
          return result.indexOf(true) > -1;
        }
        return false;
      });
      allCurrentLevel.push({ label: "", value: "" });
    }

    return (
      <div id="beneficiaryDetail" className="row">
        <div className="col-lg-6 col-sm-12 col-md-12">
          <div className="card">
            <div className="col-md-2">
              <button
                className="btn btn-default btn-fill"
                onClick={() => {
                  if (this.props.history.length <= 1)
                    this.props.history.push(
                      `/portal/application/${beneDetail.Application__c}`
                    );
                  else this.props.history.goBack();
                }}
              >
                <i className="fa fa-arrow-left" /> Back
              </button>
            </div>
            <div
              className="col-md-10 pull-right"
              style={{ textAlign: "right", display: "block" }}
            >
              <div className="btn-group">
                {buttons}

                {/* {
                                    this.state.isActive && beneDetail.RecordType.Name === 'Beneficiary' ?
                                        (<button className="btn btn-danger btn-fill" onClick={() => this.setState({ showModal: true })}>
                                            <i className="fa fa-times" />Terminate
                                        </button>)
                                        :
                                        <div />
                                } */}
                {/* modal terminate */}
                <div
                  className="modal modal-backdrop"
                  tabIndex="-2"
                  role="dialog"
                  style={{ display: this.state.showModal ? "block" : "none" }}
                >
                  <div className="modal-dialog" role="document">
                    <div className="modal-content">
                      <div className="modal-header">
                        <button
                          onClick={() => this.setState({ showModal: false })}
                          type="button"
                          className="close"
                          data-dismiss="modal"
                          aria-label="Close"
                        >
                          <span aria-hidden="true">&times;</span>
                        </button>
                        <h4 className="modal-title">termination</h4>
                      </div>
                      <div className="modal-body">
                        <p style={{ textAlign: "center" }}>
                          {this.state.loading ? (
                            <i className="fa fa-2x fa-spinner fa-spin" />
                          ) : null}
                        </p>
                        <div className="form-group">
                          <p>Beneficiary Name</p>
                          <input
                            className="form-control"
                            type="text"
                            value={beneDetail.Full_Name__c}
                            disabled
                          />
                        </div>
                        <div className="form-group">
                          <p>Termination Reason</p>
                          <textarea
                            className="form-control"
                            onChange={(e) =>
                              this.changeFormValue(
                                "Reason_for_Termination__c",
                                e.target.value
                              )
                            }
                          />
                        </div>
                        <div className="form-group">
                          <p>Termination Date</p>
                          <DatePicker
                            className="form-control"
                            selected={this.state.form.Termination_Date__c}
                            onChange={(val) =>
                              this.changeFormValue("Termination_Date__c", val)
                            }
                            showMonthDropdown
                            showYearDropdown
                            dropdownMode="select"
                          />
                        </div>
                      </div>
                      <div className="modal-footer">
                        <button
                          onClick={() => this.setState({ showModal: false })}
                          type="button"
                          className="btn btn-default"
                        >
                          Close
                        </button>
                        <button
                          onClick={() => {
                            this.createTermination();
                          }}
                          type="button"
                          className="btn btn-success btn-fill"
                        >
                          <i className="fa fa-save" />{" "}
                          {this.state.editMode ? "Update" : "Save"}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
                {/* end of modal terminate */}
              </div>
            </div>
            <div className="clearfix" />
            <hr />
            <p style={{ textAlign: "center" }}>
              {this.state.loading ? (
                <i className="fa fa-3x fa-spinner fa-spin" />
              ) : null}
            </p>
            <h4>Basic Information</h4>
            <hr />
            <BeneficiaryInformation
              editMode={editMode}
              applicationDetail={applicationDetail}
              beneDetail={beneDetail}
              onFormChanged={this.onChange}
              getPicklist={this.getPicklist}
              schoolList={schoolList}
              errorMessage={this.state.errorMessage}
            />
            {beneDetail.RecordType.Name === "Beneficiary" ? (
              <div>
                <h4>Application Information</h4>
                <hr />
                <BeneficiaryAppInformation
                  editMode={editMode}
                  beneDetail={beneDetail}
                  schoolList={schoolList}
                  allCurrentLevel={allCurrentLevel}
                  getPicklistBene={(field) => {
                    return getPicklistPerson(
                      field,
                      this.props.objectInfo.Person__c,
                      "object"
                    );
                  }}
                  onFormChanged={this.onChange}
                />
              </div>
            ) : null}
            <h4>Contact Details</h4>
            <BeneficiaryContactDetail
              editMode={editMode}
              beneDetail={beneDetail}
              contactDetail={contactDetail}
              onFormChanged={this.onChange}
              getPicklist={this.getPicklist}
              errorMessage={this.state.errorMessage}
            />
            {this.props.user.loggedInUser.Partner_Authority__c !== null ? (
              <div>
                <h4>For Official Use</h4>
                <BeneficiaryForOfficialUse
                  editMode={beneDetail.Application_Status__c === "Received"}
                  beneDetail={beneDetail}
                  partnerType={partnerType}
                  onFormChanged={this.onChange}
                  getPicklist={this.getPicklist}
                  getApprover={this.getApprover}
                  approver={this.state.approver}
                  approverAttribute={{
                    modalToggle: (value) =>
                      this.setState({ approverModalVisible: value }),
                    modalVisible: this.state.approverModalVisible,
                    submitApprover: async (approver) => {
                      await this.submitApprover(approver);
                      this.setState({ approverModalVisible: false });
                      swal({
                        text: "Approver Selected.",
                        title: "Success!",
                        type: "success",
                      });
                    },
                  }}
                />
              </div>
            ) : null}
            <div className="clearfix" />
            <div className="row">
              <div className="col-sm-12">
                <h4>Remarks</h4>
                <textarea
                  type="number"
                  className="form-control"
                  value={beneDetail.Remarks__c || ""}
                  disabled={!editMode}
                  onChange={(e) => this.onChange("Remarks__c", e.target.value)}
                  rows={3}
                />
              </div>
            </div>
            <TrackedField
              objectName="Person__c"
              salesforceId={this.props.match.params.id}
              hashToken={this.props.user.siteToken.hash}
            />
          </div>
        </div>
        {beneDetail.RecordType.Name === "Beneficiary" ? (
          <div className="col-lg-6">
            <BeneReceiptList
              userType={this.props.user.loggedInUser.Partner_Authority__c}
              beneficiaryId={this.props.match.params.id}
              token={this.props.user.siteToken.hash}
              publicKey={this.props.user.key}
            />
            <BeneficiaryAttachment
              attachmentList={this.state.attachmentList.records}
              newAttachments={this.state.newAttachments}
              onUpload={this.onUpload}
              onRemove={this.onRemove}
              onSaveUpload={this.onSaveUpload}
              userType={this.props.user.loggedInUser.Partner_Authority__c}
              token={this.props.user.siteToken.hash}
              publicKey={this.props.user.key}
            />
          </div>
        ) : (
          <div className="col-lg-6" />
        )}
      </div>
    );
  }
}

BeneficiaryDetail.propTypes = {
  user: PropTypes.object.isRequired,
  match: PropTypes.object.isRequired,
  objectInfo: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      describeAllObject,
      getAllSchool,
    },
    dispatch
  );

const mapStateToProps = (state) => ({
  user: state.user,
  salesforce: state.salesforce,
  objectInfo: state.objectInfo,
  schoolList: state.salesforce.schoolList.fields,
});

export default connect(mapStateToProps, mapDispatchToProps)(BeneficiaryDetail);



//////////////////
// WEBPACK FOOTER
// ./src/components/Portal/Beneficiary/BeneficiaryDetail.js
// module id = 798
// module chunks = 0